export default "__VITE_ASSET__BrumRITy__"